import { render, staticRenderFns } from "./SmsPartnerTariffZoneGroup.vue?vue&type=template&id=03d7d419&"
import script from "./SmsPartnerTariffZoneGroup.vue?vue&type=script&lang=ts&"
export * from "./SmsPartnerTariffZoneGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports